import React from 'react';
import {
  ResponsiveContainer,
  XAxis,
  Bar,
  BarChart,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend
} from 'recharts';

const StackedBarChart = ({ data, chartConfig }) => {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart data={data} maxBarSize={80}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          dataKey={chartConfig.Xkey}
          type="category"
          tickLine={false}
          height={20}
          {...(chartConfig.xAxis ?? {})}
        />
        <YAxis width={50} {...(chartConfig.yAxis ?? {})} />
        <Tooltip content={chartConfig.tooltipContent} cursor={false} />
        <Legend
          verticalAlign={chartConfig.legend?.verticalAlign ?? 'top'}
          align={chartConfig.legend?.align ?? 'center'}
          wrapperStyle={{ fontSize: 12, ...chartConfig.legend?.wrapperStyle }}
          iconSize={18}
          formatter={chartConfig.legend?.formatter}
        />
        {chartConfig.YkeyList.map((item, index) => (
          <Bar key={index} dataKey={item.dataKey} name={item.label} fill={item.color} stackId="a" />
        ))}
      </BarChart>
    </ResponsiveContainer>
  );
};

export default StackedBarChart;
